export default function useGuards() {
  const { createToast } = useToasts()
  const { getChromeExtensionVersion } = useExtension()
  const { toggleModal } = useOverlays()
  const billingStore = useBillingStore()
  const localePath = useLocalePath()
  const router = useRouter()
  const userStore = useUserStore()

  const extensionOnly = async () => {
    const version = await getChromeExtensionVersion()

    if (!version) {
      router.push(localePath('auth-login'))

      createToast({
        message: 'extensionRequired',
        status: 'warning',
      })

      return false
    }

    return true
  }

  const subscriberOnly = (params?: {
    data?: ModalData
    popup?: boolean
    popupTitle?: string
  }) => {
    if (!billingStore.isSubscriptionActive) {
      if (params?.popup) {
        toggleModal({
          data: params?.data,
          opened: true,
          title: params?.popupTitle,
          type: 'subscription',
        })
      }
      else {
        router.push(localePath('settings-subscription'))
      }

      createToast({
        message: 'subscriptionRequired',
        status: 'warning',
      })

      return false
    }

    return true
  }

  const userOnly = (params?: { data?: ModalData, popup?: boolean, title?: string }) => {
    if (!userStore.user) {
      if (params?.popup !== false) {
        toggleModal({
          data: {
            ...params?.data,
            currentView: 'login',
          },
          opened: true,
          title: params?.title,
          type: 'auth',
        })
      }

      createToast({
        message: 'authRequired',
        status: 'warning',
      })

      return false
    }

    return true
  }

  const visitorOnly = () => {
    if (userStore.user) {
      router.push(localePath('settings'))

      createToast({
        message: 'authAlreadyAuthenticated',
        status: 'warning',
      })

      return false
    }

    return true
  }

  const awaitUser = async (params: {
    onClose?: () => void
    onSuccess?: () => void
    title?: string
  }) => {
    if (!userStore.user) {
      const userSuccess = await new Promise(
        resolve => toggleModal({
          data: { currentView: 'login' },
          onClose: () => {
            if (params.onClose) {
              params.onClose()
            }

            resolve(false)
          },
          onSuccess: () => {
            if (params.onSuccess) {
              params.onSuccess()
            }

            resolve(true)
          },
          opened: true,
          title: params.title,
          type: 'auth',
        }),
      )

      return userSuccess
    }

    // Call onSuccess if provided
    if (params.onSuccess) {
      params.onSuccess()
    }

    return true
  }

  return {
    awaitUser,
    extensionOnly,
    subscriberOnly,
    userOnly,
    visitorOnly,
  }
}
